import { useRecoilState } from "recoil";

import { fetchDeleteAdminCalibration } from "api/admin/contents.calibration";
import { BoxInner, TextBox } from "style/admin/layout";
import { calibrationDeleteTriggerState } from "atoms/admin/contents/calibration.state";

interface CalibrationDeleteModalProps {
  closedHandler: () => void;
  orderNo?: number;
  calibrationSerial?: string;
  calibrationId?: number;
}

export function CalibrationDeleteModal({
  closedHandler,
  orderNo,
  calibrationSerial,
  calibrationId,
}: CalibrationDeleteModalProps) {
  const [calibrationDeleteTrigger, setCalibrationDeleteTrigger] = useRecoilState(calibrationDeleteTriggerState);
  const calibrationDeleteClicked = async (id: number) => {
    try {
      const response = await fetchDeleteAdminCalibration({ id });
      if (response.result) {
        setCalibrationDeleteTrigger(calibrationDeleteTrigger + 1);
        closedHandler();
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <BoxInner>
      <TextBox style={{ minHeight: "auto" }}>
        <p>아래 캘리브레이션 삭제하시겠습니까?</p>
        <span>순번 {orderNo ? orderNo : ""}</span>
        <span>시리얼번호 {calibrationSerial ? calibrationSerial : ""}</span>
      </TextBox>
      <div className="btn-box">
        <button className="continue" onClick={closedHandler}>
          돌아가기
        </button>
        <span></span>
        <button
          className="del"
          onClick={() => {
            calibrationId && calibrationDeleteClicked(calibrationId);
          }}
        >
          삭제하기
        </button>
      </div>
    </BoxInner>
  );
};
